import { Avatar, Box, Paper, Typography } from '@mui/material';
import { formatCpfCnpj, formatDateBR } from '../../utils';
import { useTranslation } from '../../hooks/useTranslation';

// Gera as iniciais a partir do nome completo
const getInitials = (name = '') => {
  const parts = name.trim().split(' ').filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const CustomerCard = ({ data }) => {
  const { t } = useTranslation();
  if (!data) return null;

  const initials = getInitials(data.full_name);
  const name = data.full_name || '—';
  const taxvar = data.taxvar || '—';
  const createdAt = formatDateBR(data.created_at);

  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
        py: 2,
        borderRadius: 3,
        mb: 3,
        borderColor: '#e5e7eb',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Avatar
          sx={{
            bgcolor: '#e5e7eb',
            color: '#6b7280',
            fontWeight: 600,
            fontSize: 14,
            width: 50,
            height: 50,
          }}
        >
          {initials}
        </Avatar>

        <Box>
          <Typography fontWeight={700} fontSize={15} color="#1f2937">
            {name}
          </Typography>
          <Typography fontSize={13} color="#6b7280">
            {formatCpfCnpj(taxvar)}
          </Typography>
        </Box>
      </Box>

      <Typography fontSize={13} color="#9ca3af">
        {t('forms.registerDate')}: {createdAt}
      </Typography>
    </Paper>
  );
};

export default CustomerCard;
